import instance from "../axios_base";

//�n�J
export let apiLogin = (account, password, company) =>
  instance.post("/Account/Login", { account, password, company });

//�޲z���n�J
export let apiAdminLogin = (account, password) =>
  instance.post("/Account/AdminLogin", { account, password });

//���o�b���򥻸��
export let apiGetUser = (UserGUID) =>
  instance.get(`/Account/GetUser/?UserGUID=${UserGUID}`);

//���o�b��
export let apiGetAllUsers = (Account, UserName) =>
  instance.post("/Account/GetAllUsers", {
    UserGuid: "1",
    Account,
    UserName,
  });

//���o�����ӦW��
export let apiGetUserName = (account) =>
  instance.get(`/Account/GetUserName/?Account=${account}`);

//���o�Ҧ�������
export let apiGetSupplier = () => instance.get(`/Account/GetSupplier/`);

//���o�Ҧ���o�H��
export let apiGetRD = () => instance.get(`/Account/GetRD/`);

//���ҵn�J���A(Token)�B���o�b�����
export let apiAccountVerify = () => instance.post("/Account/Verify");

//���o���ⶵ��
export let apiGetRoleItems = () => instance.get(`/Account/GetRoleItems/`);

//�ۦ���K�X(�������±K�X)
export let apiChangePassword = (OldPassword, NewPassword) =>
  instance.post("/Account/ChangePassword", { OldPassword, NewPassword });

//�޲z�����K�X
export let apiSetPassword = (UserGUID, Password) =>
  instance.post("/Account/SetPassword", { UserGUID, Password });

//�s�ɱb��
export const apiSave = (
  UserGuid,
  Email,
  BackupEmail,
  Role,
  ContactPerson,
  UserName,
  ERPCode,
  Enabled,
  Company
) =>
  instance.post("/Account/Save", {
    UserGuid,
    Email,
    BackupEmail,
    Role,
    ContactPerson,
    UserName,
    ERPCode,
    Enabled,
    Company,
  });
//�b�����U
export const apiRegister = (
  UserGuid,
  Account,
  Password,
  Email,
  BackupEmail,
  Role,
  ContactPerson,
  UserName,
  ERPCode,
  Company
) =>
  instance.post("/Account/Register", {
    UserGuid,
    Account,
    Password,
    Email,
    BackupEmail,
    Role,
    ContactPerson,
    UserName,
    ERPCode,
    Company,
  });
